import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { useTableSearchState } from '@/hooks/useTableSearchState';

type ReadersCatalogSearchContextValue = {
  searchInput: string;
  setSearchInput: (value: string) => void;
  debouncedSearch: string;
  clearSearch: () => void;
};

const ReadersCatalogSearchContext = createContext<ReadersCatalogSearchContextValue | null>(null);

export function ReadersCatalogSearchProvider({ children }: { children: ReactNode }) {
  const { searchInput, setSearchInput, debouncedSearch, clearSearch } = useTableSearchState();

  const value = useMemo(
    () => ({
      searchInput,
      setSearchInput,
      debouncedSearch,
      clearSearch,
    }),
    [searchInput, setSearchInput, debouncedSearch, clearSearch]
  );

  return (
    <ReadersCatalogSearchContext.Provider value={value}>{children}</ReadersCatalogSearchContext.Provider>
  );
}

export function useReadersCatalogSearch(): ReadersCatalogSearchContextValue {
  const ctx = useContext(ReadersCatalogSearchContext);
  if (!ctx) {
    throw new Error('useReadersCatalogSearch must be used within ReadersCatalogSearchProvider');
  }
  return ctx;
}
